import React from "react"
import { useStaticQuery, graphql } from "gatsby"

export const withBrand =
  Component =>
  ({ componentName = "Brand", theme, ...props }: any) => {
    const brandmarks = useStaticQuery(
      graphql`
        {
          dark: file(relativePath: { eq: "Hommey_Brandmark_Black_RGB.png" }) {
            childImageSharp {
              gatsbyImageData(width: 800, layout: CONSTRAINED)
            }
          }
          blue: file(relativePath: { eq: "Hommey_Brandmark_Blue_RGB.png" }) {
            childImageSharp {
              gatsbyImageData(width: 800, layout: CONSTRAINED)
            }
          }
          burnt: file(relativePath: { eq: "Hommey_Brandmark_Brown_RGB.png" }) {
            childImageSharp {
              gatsbyImageData(width: 800, layout: CONSTRAINED)
            }
          }
          beige: file(relativePath: { eq: "Hommey_Brandmark_Milk_RGB.png" }) {
            childImageSharp {
              gatsbyImageData(width: 800, layout: CONSTRAINED)
            }
          }
          pink: file(relativePath: { eq: "Hommey_Brandmark_Pink_RGB.png" }) {
            childImageSharp {
              gatsbyImageData(width: 800, layout: CONSTRAINED)
            }
          }
          punch: file(relativePath: { eq: "Hommey_Brandmark_Tomato_RGB.png" }) {
            childImageSharp {
              gatsbyImageData(width: 800, layout: CONSTRAINED)
            }
          }
          yellow: file(relativePath: { eq: "Hommey_Brandmark_Yellow_RGB.png" }) {
            childImageSharp {
              gatsbyImageData(width: 800, layout: CONSTRAINED)
            }
          }
          afterPay: file(relativePath: { eq: "afterpay-badge-blackonmint.png" }) {
            childImageSharp {
              gatsbyImageData(width: 200, layout: CONSTRAINED)
            }
          }
        }
      `
    )

    const brand = brandmarks[theme] ? brandmarks[theme] : brandmarks.dark

    Component.displayName = componentName
    return <Component {...props} brand={brand} />
  }
